const saveDataToast = {
    button: '[EN] ZAPISZ',
    header: '[EN] Ostrzeżenie',
    body: '[EN] Nie zapomnij zapisać zmian!',
};

export default saveDataToast;